import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { AuthApi } from '../../shared/services/api/auth.api';
import { AuthService } from '../../core/services/auth.service';
import { catchError, EMPTY, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { InfoMessageComponent } from '../../shared/components/info-message/info-message.component';
import { AsyncPipe } from '@angular/common';
import { SafeHtmlPipe } from '../../shared/pipes/safe-html-pipe';
import { TextResourcePipe } from '../../shared/pipes/text-resource.pipe';
import { NormalizeNbspPipe } from '../../shared/pipes/normalize-nbsp.pipe';
import { APP_PATHS } from '../../core/config/app-paths';
import { Router } from '@angular/router';
import { HttpResponseService } from '../../core/services/http-error-response.service';
import { SessionCounterService } from '../../core/services/session-counter.service';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [
    Button,
    TooltipModule,
    Checkbox,
    FormsModule,
    InfoMessageComponent,
    AsyncPipe,
    SafeHtmlPipe,
    TextResourcePipe,
    NormalizeNbspPipe,
  ],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionsComponent {
  readonly #destroyRef = inject(DestroyRef);
  readonly #authApi = inject(AuthApi);
  readonly #authService = inject(AuthService);
  readonly #sessionCounterService = inject(SessionCounterService);
  readonly #httpResponseService = inject(HttpResponseService);
  readonly #router = inject(Router);

  #user = computed(() => this.#authService.getUser());
  protected termsAndConditions = input<string>();

  protected isAaccepted: boolean = false;

  protected acceptTermsAndConditions(): void {
    this.#authApi
      .acceptTermsAndConditions$()
      .pipe(
        tap((isAccepted) => {
          if (this.#user() != null) {
            this.#user()!.zmianaRegulaminu = !isAccepted;
          }
          this.#router.navigate([APP_PATHS.home]);
        }),
        catchError((err) => {
          this.#httpResponseService.showErrorMessage(
            err,
            'Wystąpił błąd podczas akceptacji regulaminu',
          );
          return EMPTY;
        }),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }

  protected logOut(): void {
    this.#sessionCounterService.endSession();
  }
}
